import produce from 'immer';

import permissionsText from '@constants/permissions';

import type {
  EntryList,
  Feature,
  FeaturesObject,
  PermissionsSections,
  SchemaList,
  SchemaRoles,
} from './types';

/**
 * Builds features access list
 */
export const buildFeatures = (features: FeaturesObject): Array<Feature> => {
  const list: EntryList = Object.entries(features) as EntryList;

  return list.reduce((accumulator: Array<Feature>, currentValue) => {
    if (permissionsText.hasOwnProperty(currentValue[0])) {
      accumulator.push({
        id: currentValue[0],
        name: permissionsText[currentValue[0]],
        view: currentValue[1] >= 1,
        modify: currentValue[1] === 2,
      });
      return accumulator;
    }

    return accumulator;
  }, []);
};

/**
 * Builds Filing and Settings sections
 */
export const buildFilingSettingsSections = (roles: SchemaRoles): PermissionsSections => {
  const list: SchemaList = Object.entries(roles) as SchemaList;

  return list.reduce(
    (accumulator: PermissionsSections, currentValue) => {
      if (currentValue[0] === 'vatNumber') {
        return produce(accumulator, draft => {
          draft.filing.features = buildFeatures(currentValue[1]);
        });
      }

      return produce(accumulator, draft => {
        draft.settings.features.push(...buildFeatures(currentValue[1]));
      });
    },
    { filing: { name: 'Filing', features: [] }, settings: { name: 'Settings', features: [] } }
  );
};
